@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

// The shared Drawer is a fixed 600px wide panel with no mobile breakpoint,
// which clips its content on narrow viewports. `className` on <Drawer> only
// reaches its outer wrapper, not the sized panel itself, so we scope this
// override under that wrapper and reach the panel via its `data-drawer-container`
// hook — instance-only, no change to the shared Drawer component.
.root {
  [data-drawer-container] {
    @include respond-to('mobile') {
      width: 100%;
    }
  }
}

.drawerTitle {
  @include typography-v2-title-md;
  color: var(--text-default);
  margin: 0;
}

.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 28px;
  flex: 1;
  min-height: 0;
  padding: 24px 24px 20px;
  overflow: hidden;
}

.description {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  margin: 0;
  line-height: 1.5;
}
